import PrimeVue from 'primevue/config'
import InputSwitch from 'primevue/inputswitch'
import Message from 'primevue/message'
import Dialog from 'primevue/dialog'
import Divider from 'primevue/divider'
import TabMenu from 'primevue/tabmenu'
import Sidebar from 'primevue/sidebar'
import PrimeVueColorPicker from 'primevue/colorpicker'
import ProgressBar from 'primevue/progressbar'
import ToastService from 'primevue/toastservice'
import FileUpload from 'primevue/fileupload'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ColumnGroup from 'primevue/columngroup'
import Row from 'primevue/row'
import Menu from 'primevue/menu'
import Skeleton from 'primevue/skeleton'
import MultiSelect from 'primevue/multiselect'
import RadioButton from 'primevue/radiobutton'
import ProgressSpinner from 'primevue/progressspinner'
import Tooltip from 'primevue/tooltip'
import ConfirmationService from 'primevue/confirmationservice'
import AutoComplete from 'primevue/autocomplete'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(PrimeVue, { ripple: true })
  nuxtApp.vueApp.use(ToastService)
  nuxtApp.vueApp.use(ConfirmationService)
  nuxtApp.vueApp.directive('tooltip', Tooltip)
  // Importing Components as needed.
  nuxtApp.vueApp.component('Message', Message)
  nuxtApp.vueApp.component('AutoComplete', AutoComplete)
  nuxtApp.vueApp.component('RadioButton', RadioButton)
  nuxtApp.vueApp.component('FileUpload', FileUpload)
  nuxtApp.vueApp.component('DataTable', DataTable)
  nuxtApp.vueApp.component('ColumnGroup', ColumnGroup)
  nuxtApp.vueApp.component('Row', Row)
  nuxtApp.vueApp.component('Column', Column)
  nuxtApp.vueApp.component('TabMenu', TabMenu)
  nuxtApp.vueApp.component('Dialog', Dialog)
  nuxtApp.vueApp.component('InputSwitch', InputSwitch)
  nuxtApp.vueApp.component('ColorPicker', PrimeVueColorPicker)
  nuxtApp.vueApp.component('ProgressBar', ProgressBar)
  nuxtApp.vueApp.component('ProgressSpinner', ProgressSpinner)
  nuxtApp.vueApp.component('VMenu', Menu)
  nuxtApp.vueApp.component('Skeleton', Skeleton)
  nuxtApp.vueApp.component('Divider', Divider)
  nuxtApp.vueApp.component('MultiSelect', MultiSelect)
  nuxtApp.vueApp.component('Sidebar', Sidebar)
})
